import { render, staticRenderFns } from "./load-list.vue?vue&type=template&id=b97e4942&scoped=true"
import script from "./load-list.vue?vue&type=script&lang=js"
export * from "./load-list.vue?vue&type=script&lang=js"
import style0 from "./load-list.vue?vue&type=style&index=0&id=b97e4942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97e4942",
  null
  
)

export default component.exports